import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';

import {LoginGuard} from 'shared/guards/login.guard';
import {CategoriesComponent} from './categories.component';

const routes: Routes = [
  {path: 'targetgroups/categories', component: CategoriesComponent, canActivate: [LoginGuard]},
];

@NgModule({
  imports: [
    RouterModule.forChild(routes),
  ],
  exports: [
    RouterModule,
  ],
})

export class CategoriesRoutingModule { }



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/target-groups/categories/categories-routing.module.ts